

export function getOrganizationFromUser(user) {

    try {

        const { organization } = user.CurrentUser.teams[0]

        if (organization != null && organization.id) {
            return {
                [organization.id]: organization
            }
        }

    } catch (err) {
        // No org, no worries
    }

    return {}
}